import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import Spinner from '../Spinner';
import StoryForm from './StoryForm';

const StoriesNewForm = ({ from, onSuccess, onBack }) => {
  const fetch = useFetch();
  const [error, setError] = useState();
  const [pages, setPages] = useState();
  const { accountId, domainId } = useParams();

  const [story, setStory] = useState();

  useEffect(() => {
    if (!from) {
      setStory({
        name: 'New story',
        autoPlayDurationSeconds: 5,
        endBehavior: 'dismiss',
        type: 'showAlways',
        reentrable: false,
        reentryCooldownInDays: 7,
        reentryCooldownInHours: 0,
        tags: [],
        segmentRelationship: 'and',
        inverseSegmentSelection: false,
        progressIndicatorColor: '#333333',
        progressIndicatorInactiveColor: '#33333340',
        trigger: 'immediately',
        urlCondition: 'any',
        slides: [],
      });
    } else {
      fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/stories/${from}`)
        .then(({ story }) => {
          setStory({
            ...story,
            id: undefined,
            name: `Copy of ${story.name}`,
            slides: (story.storySlides || []).map((s) => ({ ...s, id: undefined })),
          });
        })
        .catch(setError);
    }
  }, [fetch, accountId, domainId, from]);

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pages`)
      .then(({ pages }) => {
        setPages(pages);
      })
      .catch(setError);
  }, [fetch, accountId, domainId]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (story === undefined || pages === undefined) {
    return <Spinner />;
  }

  return <StoryForm story={story} pages={pages} cancel={onBack} onSuccess={onSuccess} />;
};

export default StoriesNewForm;
